export default {
    baseStyle: (props) => ({
        root: {
            backgroundColor: 'white',
            width: '100%'
        },
        container: {
            direction: 'column'
        },
        layout: {
            direction: ['column', 'column', 'column', 'row']
        },
        qvContainer: {
            width: '100%',
            padding: 2
        },
        variationsStack: {
            spacing: 1,
            alignItems: 'flex-start',
            overflow: 'hidden',
            width: '100%',
            gap: {lg: 0}
        },
        skeletonStack: {
            width: '100%',
            alignItems: 'stretch',
            spacing: 2
        },
        skeletonStackMinHeight: {
            base: '156px',
            lg: '86px'
        },
        skeletonStackMinHeightLong: {
            base: '232px',
            lg: '172px'
        },
        skeletonGroup: {
            width: '100%'
        },
        skeletonLabel: {
            height: '18px',
            width: '96px',
            mb: 2
        },
        skeletonControlCompact: {
            height: {base: '24px', lg: '28px'},
            width: {base: '64%', lg: '50%'}
        },
        skeletonControl: {
            height: {base: '44px', lg: '44px'},
            width: '100%',
            mb: 2
        },
        variationWrapper: {
            width: {base: 'auto', lg: '100%'},
            marginTop: {base: 0, lg: 2},
            marginBottom: {base: 0, lg: 2}
        },
        variationRow: {
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        variationLabelRow: {
            justifyContent: 'space-between',
            alignItems: 'left'
        },
        variationLabel: {
            color: 'webTypo.textPrimary',
            textStyle: 'bodyXsRegular',
            mb: 2
        },
        fewItemsLeftDesktop: {
            color: 'webTypo.textPrimary',
            textStyle: 'bodyXsRegular',
            mt: 0,
            mb: 2,
            ml: 1
        },
        errorMessageDesktop: {
            color: 'webTypo.textError',
            textStyle: 'bodyXsRegular',
            mt: 0,
            mb: 2
        },
        fewItemsLeftMobile: {
            mt: 0,
            mb: 2,
            ml: 1
        },
        errorMessageMobile: {
            mt: 0,
            mb: 2
        },
        desktopHeading: {},
        swiperSlide: {
            width: 'auto',
            paddingTop: '2px'
        },
        swatchImage: {
            height: '100%',
            width: '100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover'
        },
        swatchText: {
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textStyle: 'bodyXsRegular',
            letterSpacing: '0',
            ...(props.selected && {
                color: 'webTypo.textPrimaryReverse'
            }),
        },
        notifyMeIcon: {
            width: '11px',
            height: '11px',
            position: 'absolute',
            top: '-3px',
            right: '2px'
        },
        fewItemsLeftIcon: {
            position: 'absolute',
            top: '1',
            right: '1'
        },
        actionsContainer: {
            width: '100%'
        },
        notifyMeButton: {
            width: '100%',
            variant: 'solid',
            marginBottom: {base: 4, lg: 0},
            height: {base: '44px', lg: 10},
            textStyle: 'cta',
            color: 'webTypo.textOnColor',
            bg: 'webButton.btnPrimaryDefault',
            _hover: {
                bg: 'webButton.btnPrimaryHover'
            }
        },
        notifyMeError: {
            color: 'webTypo.textError',
            mt: '-16px',
            mb: 4
        },
        cartButton: {
            width: '100%',
            variant: 'solid',
            height: {base: '44px', lg: 10},
            marginBottom: {base: 4, lg: 0},
            textStyle: 'cta',
            color: 'webTypo.textOnColor',
            bg: 'webButton.btnPrimaryDefault',
            _hover: {
                bg: 'webButton.btnPrimaryHover'
            }
        },
        closeButtonContainer: {
            position: 'absolute',
            right: '8px',
            top: '8px'
        },
        colorVariationLabel: {
            display: 'none'
        },
        fullProductLink: {
            width: '100%',
            maxWidth: {base: '236px', lg: '100%'},
            display: 'flex',
            gap: 5,
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        fullProductText: {
            textStyle: 'bodySmRegular'
        },
        fullProductIcon: {
            width: '24px',
            height: '24px'
        },
        maxQtyErrorText: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textError'
        }
    }),
    variants: {
        QuickView: {
            layout: {
                flexDirection: {base: 'column'}
            },
            qvContainer: {
                gap: 5,
                alignItems: 'flex-start',
                padding: '0 16px 96px'
            },
            variationsStack: {
                gap: 5,
                width: '100%'
            },
            mobileHeaderStack: {
                maxWidth: {lg: '100%'},
                gap: 6,
                mb: {base: 5, lg: 4},
                mt: {base: '56px', lg: 0}
            },
            mobileHeaderImageWrapper: {
                flex: 1
            },
            mobileHeaderTextWrap: {
                px: 4
            },
            mobileHeaderTitleSkeleton: {
                height: '18px',
                width: '70%'
            },
            mobileHeaderPriceSkeleton: {
                height: '18px',
                width: '88px',
                mt: 2
            },
            mobileHeaderLikesSkeleton: {
                height: '20px',
                width: '20px',
                borderRadius: '50%'
            },
            mobileHeaderTitleRow: {
                justifyContent: 'space-between',
                alignItems: 'center'
            },
            mobileHeaderTitle: {
                color: 'webTypo.textPrimary',
                textStyle: 'labelXs',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            },
            mobileHeaderLikes: {
                alignItems: 'center',
                gap: 2
            },
            mobilePrice: {
                textStyle: 'labelXs',
            },
            mobileListPrice: {
                color: 'webTypo.textPrimary',
                textStyle: 'labelXs',
                mt: 1
            },
            mobileCurrentPrice: {
                color: 'webTypo.textPrimary',
                textStyle: 'labelXs',
                mt: 1
            },
            closeButtonContainer: {
                position: 'absolute',
                right: 4,
                top: 4,
                zIndex: 2,
                backgroundColor: {lg: 'white'},
                opacity: {lg: '0.5'},
                height: {lg: '24px'},
                filter: 'blur(10)'
            },
            colorVariationLabel: {
                display: 'block',
                mb: {base: '18px', lg: 1}
            },
            colorSwatchGrid: {
                lineHeight: {base: '24px', lg: '16px'},
                gap: {base: 0, lg: 1},
                marginX: {base: '-8px', lg: 0},
                flexWrap: 'wrap'
            },
            swatchGrid: {
                gap: 1,
                flexWrap: 'wrap'
            },
            actionsContainer: {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 2,
                backgroundColor: 'white',
                padding: 4,
                borderTop: '1px solid',
                borderColor: 'webTheme.strokeTertiary'
            },
            cartButton: {
                marginBottom: 0
            },
            skeletonStack: {
                width: '100%',
                alignItems: 'stretch',
                spacing: 3
            },
            skeletonStackMinHeight: {
                base: '156px',
                lg: '132px'
            },
            skeletonStackMinHeightLong: {
                base: '232px',
                lg: '196px'
            },
            skeletonLabel: {
                height: '12px',
                width: '96px',
                mb: 2
            },
            skeletonControl: {
                height: {base: '44px', lg: '32px'},
                width: '100%'
            },
            variationWrapper: {
                width: {base: 'unset', lg: 'unset'},
                marginTop: {base: 0, lg: 0},
                marginBottom: {base: 0, lg: 0}
            }
        }
    }
}
